import type {Door, GridPoint} from "@/dungeons/model/DungeonGeometry.ts";

export const doorAppearance = (door: Door, zoom: number) => ({
    stroke: door.secret ? "#c084fc" : door.initialState === "OPEN" ? "#10b981" : "#f59e0b",
    dash: door.secret || door.initialState === "OPEN" ? [6 / zoom, 4 / zoom] : undefined,
});

export const doorHitPoints = (start: GridPoint, end: GridPoint, zoom: number) => {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const length = Math.hypot(dx, dy);
    if (length === 0) return [start.x, start.y, end.x, end.y];
    const trim = Math.min(16 / zoom, length / 4);
    const factor = trim / length;
    return [
        start.x + dx * factor,
        start.y + dy * factor,
        end.x - dx * factor,
        end.y - dy * factor,
    ];
};
